import React from "react";

import { SignatureSuccess as StyledSignatureSuccess } from "./SignatureSuccess.styles.js";

import Loading from "../../components/Loading";
import SignboxLogo from "../../assets/images/signbox.svg"
import successPure from "../../assets/images/success-pure.svg"

const FORM_TYPE = {
	HEALTH: 'HEALTH',
	UNHEALTH: 'UNHEALTH'
};

function SignatureSuccess ({ form, isDesktop }) {
	if (!form) {
		return <Loading />
	}

	return (
		<StyledSignatureSuccess className="doca">
			<div className="doca-flex doca-justify-center">
				<StyledSignatureSuccess.Image src={SignboxLogo} />
			</div>

			<div className={`doca-flex doca-flex-col doca-flex-1 doca-items-center doca-justify-center`}>
				<div className="doca-flex doca-justify-center">
					<StyledSignatureSuccess.ImageSuccess src={successPure} />
				</div>

				<div className="doca-text-center doca-mt-6">
					<StyledSignatureSuccess.Title className="doca-text--extra-large doca-text--medium">O formulário foi {form.type === FORM_TYPE.HEALTH ? 'assinado' : 'respondido'} com sucesso</StyledSignatureSuccess.Title>
				</div>
			</div>
		</StyledSignatureSuccess>
	)
}

export default SignatureSuccess;
